import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

export interface StatsCardProps {
  icon: React.ReactNode
  label: string
  value: number | string
  variant?: 'default' | 'primary' | 'accent' | 'success'
  className?: string
}

const variantStyles = {
  default: 'bg-gray-50 text-gray-600',
  primary: 'bg-blue-50 text-[#0033A0]',
  accent: 'bg-purple-50 text-[#6B3FA0]',
  success: 'bg-green-50 text-green-600',
}

export function StatsCard({
  icon,
  label,
  value,
  variant = 'default',
  className,
}: StatsCardProps) {
  return (
    <Card
      className={cn(
        'transition-all hover:shadow-md active:opacity-90',
        className
      )}
    >
      <CardContent className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-500">{label}</p>
            <p className="mt-2 text-3xl font-bold text-gray-900">{value}</p>
          </div>
          <div
            className={cn(
              'flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg',
              variantStyles[variant]
            )}
          >
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
